<template>
    <header>
        <div class="l-content">
            <!-- <el-button plain icon="el-icon-menu" size="mini" @click="collapseMenu"></el-button> -->
            <i class="icons" :class="[active ? 'el-icon-s-unfold' : 'el-icon-s-fold']" size="mini"
               @click="collapseMenu"></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <!--很明显 首页 一定是存在的 所以这里直接写死-->
                <el-breadcrumb-item :to="{ path: '/dhome' }"><span style="color:white">首页</span></el-breadcrumb-item>
                <!--第二级菜单名称 就要看左侧组件有没有点击指定菜单，没有那就只显示首页 点击就显示当前菜单名称-->
                <el-breadcrumb-item :to="current.path" v-if="current"><span
                        style="color:white">{{ current.label }}</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="r-content">
            <el-dropdown trigger="click" size="mini">
				<span class="el-dropdown-link">
					<!-- <span class="username">数据库:{{user.Login_DB}}</span> -->
					<img :src="userImg" class="user"/>
					<span class="username">{{ user.username }}</span>
				</span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>个人工作区</el-dropdown-item>
                    <el-dropdown-item @click.native="logOut">退出系统</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </header>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                current: state => state.tab.currentMenu
            })
        },
        data() {
            return {
                active: true,
                userImg: require('../assets/images/user.png'),
                user: {}
            };
        },
        mounted: function () {
            var users = sessionStorage.getItem('userData');
            users = JSON.parse(users);
            this.user = users;
            this.collapseMenu()
        },
        methods: {
            //控制左侧菜单是否折叠
            collapseMenu() {
                if (this.active) {
                    this.active = false;
                } else {
                    this.active = true;
                }
                this.$store.commit('collapseMenu');
            },
            //退出登陆
            logOut() {
                window.location.href = 'http://www.heclar.cn/'
                /*this.$router.push({ path: '/' });*/
                this.$store.dispatch('/logout');
            }
            // 新增
        }
    };
</script>

<style lang="scss" scoped>
    header {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: space-between;
    }

    span.username {
        color: #fff;
        display: inline-block;
        line-height: 43px;
        margin: 0 5px;
    }

    span.el-dropdown-link.el-dropdown-selfdefine {
        display: flex;
    }

    .icons {
        color: #fff;
        display: inline-block;
        font-size: x-large;
        margin-left: -20px;
        margin-right: 10px;
    }

    .l-content {
        display: flex;
        align-items: center;

        .el-button {
            margin-right: 20px;
        }
    }

    .r-content {
        .user {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
    }

    .el-breadcrumb__item {
        .el-breadcrumb__inner {
            color: #666666;
            font-weight: normal;
        }

        &:last-child {
            .el-breadcrumb__inner {
                color: #ffffff;
            }
        }
    }
</style>
